export const mutation_add_audit = `
mutation addAudit($tenantId: String!, $aziendaId: Int!, $area: String!, $operation: String!, $entityType: String!, $entityId: String!, $oldValues: String!, $newValues: String!) {
    insert_audit_one(object: {TenantId: $tenantId, AziendaId: $aziendaId, Area: $area, Operation: $operation, EntityType: $entityType, EntityId: $entityId, OldValues: $oldValues, NewValues: $newValues}) {
        Id
    }
}`;